import * as React from 'react';
import { PromptConfirmation } from 'ui';
import { CodetableListComponentProps } from 'app/area/codetable/list/list-items/types';

export const DragPromptConfirmation = (props: CodetableListComponentProps) => {

  const { confirmPrompt: { show, codetableId, codeId, description } = {},
    translation, deleteCodeItem, updateConfirmPrompt } = props;

  const handleDeleteCodeItem = () => {
    deleteCodeItem({
      codetableId,
      codeId,
      successMessage: translation.code_item_successfully_deleted,
      violationErrorMessage: translation.merge_code_violation_error
    });
  };

  const hideConfirmPrompt = () =>
    updateConfirmPrompt(undefined);

  return !!show
    ? <PromptConfirmation
      title={translation.delete_code_item_title}
      description={description}
      continueText={translation.delete}
      cancelText={translation.cancel}
      onContinue={handleDeleteCodeItem}
      onCancel={hideConfirmPrompt} />
    : null;
};
